<div mat-dialog-content class="margin-0">
    <p class="font-14">
      <br />
      <span class="info-title"> {{data.title | translate}}</span>
      <br><br>
      <span class="info-msg"> {{data.description | translate }}</span>
    </p>
</div>

<mat-dialog-actions align="center">
    <app-button [btnOption]="btnOptions['primary']" (clickEvent)="onConfirmClick()">
    </app-button>

</mat-dialog-actions>
